// ============================================================================
// BOOT SPLASH (issue #53)
// ============================================================================
// A minimal, theme-neutral loading splash shown while the runtime tenant config
// is hydrated on a cold start (no localStorage cache yet). It uses inline styles
// only — no theme, no CSS bundle — so it can paint instantly before any app
// module is imported. React's `createRoot(...).render()` replaces it.
// ============================================================================

const SPLASH_ID = "cc-boot-splash";

/** Inject the splash into the app root (no-op if already present or no DOM). */
export function showSplash(): void {
  if (typeof document === "undefined") return;
  const root = document.getElementById("root");
  if (!root || document.getElementById(SPLASH_ID)) return;

  const splash = document.createElement("div");
  splash.id = SPLASH_ID;
  splash.setAttribute("aria-label", "Cargando configuración");
  splash.setAttribute("role", "status");
  splash.style.cssText = [
    "position:fixed",
    "inset:0",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "background:#0b0f17",
    "z-index:2147483647",
  ].join(";");

  splash.innerHTML = `
    <div style="width:42px;height:42px;border:3px solid rgba(255,255,255,0.18);border-top-color:rgba(255,255,255,0.85);border-radius:50%;animation:cc-spin 0.8s linear infinite"></div>
    <style>@keyframes cc-spin{to{transform:rotate(360deg)}}</style>
  `;
  root.appendChild(splash);
}

/** Remove the splash if React did not already replace the root content. */
export function hideSplash(): void {
  if (typeof document === "undefined") return;
  document.getElementById(SPLASH_ID)?.remove();
}
